'use client';

import React, { ReactNode } from 'react';

import { ChannelActionsProvider } from '@/providers/ChannelActionsProvider';
import { ChannelsProvider } from '@/providers/ChannelsProvider';
import { ChatProvider as BaseChatProvider } from '@/providers/ChatContext';
import { MessagesProvider } from '@/providers/MessagesProvider';

export const ChatProvider = ({ children }: { children: ReactNode }) => {
  return (
    <BaseChatProvider>
      <ChannelsProvider>
        <ChannelActionsProvider>
          <MessagesProvider>{children}</MessagesProvider>
        </ChannelActionsProvider>
      </ChannelsProvider>
    </BaseChatProvider>
  );
};

export { useChat } from '@/providers/ChatContext';
export { useChannels } from '@/providers/ChannelsProvider';
export { useChannelActions } from '@/providers/ChannelActionsProvider';
export { useMessages } from '@/providers/MessagesProvider';
